export enum ConversationStatus {
  Completed = 'completed',
  InProgress = 'in_progress',
  Error = 'error',
}

export enum ContentBlockType {
  Text = 'text',
  BarChart = 'bar_chart',
  PieChart = 'pie_chart',
}

export interface CopilotProgress {
  message: string;
  status: ConversationStatus;
  conversation_uuid: string;
  question?: string;
  user_message_uuid?: string;
}

export interface CopilotProgressHistory {
  [conversationId: string]: {
    events: CopilotProgress[];
    lastEventTimestamp: number;
  };
}

export interface CopilotMessage {
  id: number;
  uuid: string;
  role: 'user' | 'assistant';
  data: CopilotMessageContentBlock[];
  created_at: string;
  status: ConversationStatus;
}

export interface CopilotMessageContentBlockBase {
  type: string;
}

export interface CopilotTextContentBlock extends CopilotMessageContentBlockBase {
  type: ContentBlockType.Text;
  content: string;
}

export interface CopilotBarChartContentBlock extends CopilotMessageContentBlockBase {
  type: ContentBlockType.BarChart;
  data: {
    title?: string | null;
    labels: string[];
    datasets: {
      label: string;
      data: number[];
      backgroundColor?: string;
    }[];
  };
}

export interface CopilotPieChartContentBlock extends CopilotMessageContentBlockBase {
  type: ContentBlockType.PieChart;
  data: {
    title?: string | null;
    labels: string[];
    datasets: {
      label: string;
      data: number[];
      backgroundColor?: string[];
    }[];
  };
}

// Union type for all content block types - can be extended later
export type CopilotMessageContentBlock =
  | CopilotTextContentBlock
  | CopilotBarChartContentBlock
  | CopilotPieChartContentBlock;

export interface CopilotConversation {
  id: number;
  uuid: string;
  description: string;
  created_at: string;
  updated_at: string;
  status: ConversationStatus;
  messages?: CopilotMessage[];
  requires_confirmation?: boolean;
}
